import React, { useEffect, useState } from "react";
import "./Payment.css";
import CurrencyFormat from "react-currency-format";
import { useStateValue } from "./Context";
import CheckoutProduct from "./CheckoutProduct";
import { Link } from "react-router-dom";
import { getBasketTotal } from "./reducer";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useHistory } from "react-router-dom";
import instance from "./axios";
import db from "./firebase";

export default function Payment() {
    const[{basket, user}, dispatch]= useStateValue()
  const history=  useHistory()

  const stripe = useStripe();
  const elements = useElements();

  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState(true);
  const [processing, setProcessing] = useState("");
  const [succeeded, setSucceeded] = useState(false);

  useEffect(()=>{
  const getClientSecret = async()=>{
      const response = await  instance ({
          method:"post",
          url: `/payments/create?total=${getBasketTotal(basket) * 100}`
      });
      setClientSecret(response.data.clientSecret)
  }
  getClientSecret()

  },[basket])

  console.log("The secret is", clientSecret);

  const handleSubmit = async(e) => {
  e.preventDefault();
  setProcessing(true)

  const payload = await stripe.confirmCardPayment(clientSecret,{
      payment_method:{
          card: elements.getElement(CardElement)
      }
  }).then(({ paymentIntent })=>{

    db.collection('users').doc(user?.uid).collection('orders').doc(paymentIntent.id).set({
      basket:basket,
      amount:paymentIntent.amount,
      created:paymentIntent.created
    })

      setSucceeded(true)
      setError(null)
      setProcessing(false)

      dispatch({
        type:"EMPTY_BASKET"
      })

      history.replace('/orders')
  })

  };

  const handleChange = (e) => {
    setDisabled(e.empty);
    setError(e.error ? e.error.messsage : "");
  };

  
  return (
    <div className="payment">
      <div className="payment_container">
        <h1>
          {" "}
          Checkout ( <Link to="/checkout">{basket?.length} items</Link>){" "}
        </h1>
        <div className="payment_section">
          <div className="payment_title">
            <h3>Delivery Address</h3>
          </div>
          <div className="payment_address">
            <p>{user?.email}</p>
            <p>123 los Angila</p>
            <p>New York</p>
          </div>
        </div>

        <div className="payment_section">
          <div className="payment_title">
            <h3>Reviews items and delivery</h3>
          </div>
          <div className="payment_items">
            {basket.map((item) => (
              <CheckoutProduct
                id={item.id}
                title={item.title}
                price={item.price}
                img={item.img}
                rating={item.rating}
              />
            ))}
          </div>
        </div>

        <div className="payment_section">
          <div className="payment_title">
            <h3>Payment Method</h3>
          </div>
          <div className="payment_details">
            <form onSubmit={handleSubmit}>
              <CardElement onChange={handleChange} />
              <div className="payment_priceContainer">
                <CurrencyFormat
                  renderText={(value) => (
                      <h3>Order Total: {value} </h3>
                  )}
                  decimalScale={2}
                  value={getBasketTotal(basket)} // Part of the homework
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"₹"}
                />
                <button disabled={processing || disabled || succeeded }>
                    <span>{processing ? <p>Processing</p>: "Buy Now" }</span>
                </button>
              </div>

              {error && <div>{error}</div> }
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
